// @ts-ignore - React import needed for JSX in this context
import React from 'react';
import { styled } from '@mui/material/styles';
import loadingSvg from '../../assets/img/loading.svg';

interface LoadingProps {
  active: boolean;
}

const Loading = ({ active }: LoadingProps) => {
  if (!active) return null;
  return (
    <Overlay data-testid="loading">
      <img src={loadingSvg} alt="Loading..." />
    </Overlay>
  );
};

const Overlay = styled('div')({
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  top: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  zIndex: 9999,
});

export default Loading;
